import React from "react";
import { useOrg } from "../../contexts/OrganizationContext";

function ChatWidget() {
  const { organization } = useOrg();

  const chatImplemented = organization.flags?.enableChat;
  const hasChatLink = organization.links?.chat;
  const newChat = organization.flags?.newChat;
  const chatAvailable = window.UW211?.CHAT_AVAILABLE || false;

  const isActive = chatImplemented && chatAvailable && hasChatLink;

  let statusText;
  if (isActive) {
    statusText = "Chat";
  } else if (chatImplemented) {
    statusText = "Chat Unavailable";
  } else {
    statusText = "Chat Coming Soon";
  }

  function handleClick() {
    if (isActive) {
      if (newChat) {
        window.launchChatByOpenEntryPoint();
      } else {
        window.open(
          organization.links.chat,
          "211 Chat",
          "directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=no,top=200,left=500,width=500,height=650"
        );
      }
    }
  }

  return (
    <a className="nav-link" href="#" onClick={(e) => { e.preventDefault(); handleClick(); }}>
      <span className="chat-status">{statusText}</span>
    </a>
  );
}

export default ChatWidget;
